import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { PromotionFormData } from './promotion-form'

export const PromotionUsageCard = () => {
    const { t } = useTranslation('stores')
    const { watch, setValue: rawSetValue } = useFormContext<PromotionFormData>()
    const setValue: typeof rawSetValue = (name, value, options) =>
        rawSetValue(name, value, { shouldDirty: true, ...options })

    const usageLimit = watch('usageLimit')
    const oncePerCustomer = watch('oncePerCustomer')

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t('promotion.usage.title')}</CardTitle>
                <p className="text-muted-foreground mt-1 text-sm">
                    {t('promotion.usage.description')}
                </p>
            </CardHeader>
            <CardContent className="space-y-4">
                <div>
                    <Label htmlFor="usageLimit" className="text-xs">
                        {t('promotion.fields.usageLimit')}
                    </Label>
                    <Input
                        id="usageLimit"
                        type="number"
                        value={usageLimit || ''}
                        onChange={(e) => setValue('usageLimit', parseInt(e.target.value ?? '0', 10))}
                        className="h-8"
                        placeholder={t('promotion.fields.unlimited')}
                    />
                </div>

                <div className="flex items-center gap-2">
                    <Checkbox
                        id="oncePerCustomer"
                        checked={oncePerCustomer || false}
                        onCheckedChange={(checked) => setValue('oncePerCustomer', checked === true)}
                    />
                    <Label htmlFor="oncePerCustomer" className="text-xs">
                        {t('promotion.fields.oncePerCustomer')}
                    </Label>
                </div>
            </CardContent>
        </Card>
    )
}
